<template>
  <div>
    <search></search>
    <div class="coupon_auto">
      <div class="coupon_detail_title_bg"><img :src="couponBg" alt=""></div>
      <div class="coupon_detail_title">
        <div class="coupon_detail_title_txt1">{{promotionList.useRabgeRenark}}</div>
        <div class="clearfix_">
          <p class="fl coupon_detail_title_txt2">{{promotionList.promotionCondition}}{{promotionList.goodsNum}}{{promotionList.method}}{{promotionList.conditionMethod}}{{promotionList.val}}{{promotionList.overMethod}}</p>
          <div class="fr activity_time">
            <p>距离优惠结束</p>
            <p class="clearfix_">
              <i class="fl">{{timeArr[0]}}</i>
              <b class="fl">：</b>
              <i class="fl">{{timeArr[1]}}</i>
              <b class="fl">：</b>
              <i class="fl">{{timeArr[2]}}</i>
            </p>
          </div>
          <!-- <p @click="bondCoupon(promotionList.id)" class="fr coupon_detail_title_btn">立即领取</p> -->
        </div>
      </div>
      <div class="coupon_goods_content">
        <div class="coupon_goods_content_title">
          <ul class="clearfix_">
            <li @click="comprehensiveSort" :class="{'active':comprehensiveSortType}" class="fl">综合</li>
            <li @click="salesSort" :class="{'active':salesSortType}" class="fl">销量</li>
            <li @click="priceSort" :class="{'active':priceSortType}" class="clearfix_ fl">
              <span class="fl">价格</span>
              <i class="fl">
              <img v-show="showImg==0" :src="a02" alt="">
              <img v-show="showImg==2" :src="a03" alt="">
              <img v-show="showImg==1" :src="a04" alt="">
              </i>
            </li>
          </ul>
        </div>
        <div class="coupon_goods_content_list">
          <div class="GoodsListContentBox">
            <ul class="clearfix">
              <li class="coupon_detail_goods_list_item" v-for="(goods,index) in goodsList" :key="index" :data-id="goods.id" @mouseenter="hover(index)" @mouseleave="leave(index)">
                <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId,supplyChainTenantId:goods.supplyChainTenantId,isSupplyChainGoods:2}}">
                  <div class="goodslistpicbox">
                    <img :title="goods.name" :src="goods.goodsHeadpicPath1?goods.goodsHeadpicPath1:noImg" width="225" height="225" :goodsId="goods.goodsId"/>
                  </div>
                </router-link>
                  <div class="goodslistprice clearfix_">
                    <p class="fl">¥ {{goods.price}}</p>
                  </div>
                <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId,supplyChainTenantId:goods.supplyChainTenantId,isSupplyChainGoods:2}}">
                  <div class="goodslistnamebox">
                    <p :title="goods.name">{{goods.name}}</p>
                  </div>
                </router-link>
                <div class="clearfix_">
                  <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(goods.goodsId)">查看详情</div>
                  <div class="goodslistBtnBox fl" v-show="Accord === index" @click="addCar(goods)">加入购物车</div>
                </div>
              </li>
            </ul>
            <div class="noGoods" v-show="total==0">暂时没有商品哦~！快去看看其他好商品吧~！</div>
          </div>
        </div>
        <div class="coupon_detail_goods_page">
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="12"
              layout="prev, pager, next, jumper"
              :total="this.total">
            </el-pagination>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime,formatDuring,getTimeLeft } from '../../assets/js/public.js'
import search from '@/components/index/search'
export default {
  components:{
    search
  },
  data(){
    return{
      couponBg:require('../../assets/img/activity.png'),
      noImg:require("@/assets/img/aa.png"),
      a02:require('../../assets/img/a02.png'),
      a03:require('../../assets/img/a03.png'),
      a04:require('../../assets/img/a04.png'),
      showImg:0,
      total:null,
      goodsList:{},
      tenantId:'',
      page:1,
      Accord:-1,
      promotionList:{},
      salesSortNum:0,
      salesSortType:0,
      priceSortNum:0,
      priceSortType:0,
      comprehensiveSortType:1,
      timer:null,
      timeArr:['','',''],
      isAjax:false
    }
  },
  mounted:function(){
    this.getPromotionDetails(this.page)
  },
  methods:{
    addCar:function(obj){
      var t_=this
      if(obj.attribute){
        t_.goToGoods(obj.goodsId)
      }else{
        if(t_.isAjax)return
        t_.isAjax=true
        var data0bj = {
          num: 1,
          goodsId:obj.goodsId,
          type: 1,
          goodsUnitId: obj.goodsUnitId,
          property2: '',
          channel:2,
          tamp:localStorage.tamp?localStorage.tamp:'',
          supplyChainTenantId:obj.supplyChainGoodsId
        }
        axios.post(`${ip}formWorkInterface/addShopping`,Qs.stringify(data0bj)).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if( res.data.code == 0 ){
            t_.isAjax=false
            t_.$message({
              message:res.data.message,
              center:true,
              type:'success'
            })
            t_.$store.commit('ccc')
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }
    },
    getPromotionDetails:function(page){
      var t_=this
      clearInterval(t_.timer)
      var data0bj={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        id:t_.$route.query.id,
        page:page,
        pagesize:12
      }
      if(t_.comprehensiveSortType==1)data0bj.sortName='dateCreated'
      if (t_.priceSortNum===1) {
          data0bj.sortName='price'
          data0bj.sort=1
        } else if(t_.priceSortNum===2) {
          data0bj.sortName='price'
          data0bj.sort=2
        } else if(t_.priceSortNum===0&&t_.salesSortNum===0) {
        } else if(t_.salesSortNum===1) {
          data0bj.sortName='sum'
          data0bj.sort=1
        } else if(t_.salesSortNum===2) {
          data0bj.sortName='sum'
          data0bj.sort=2
        }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/getPromotionDetails`,data0bj).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.sort==1&&res.data.sortName=='price'){
            t_.showImg=1
          }else if(res.data.sort==2&&res.data.sortName=='price'){
            t_.showImg=2
          }
          // t_.$set(res.data.promotionList,"timeArr",[0,0,0])
          t_.goodsList=res.data.rows
          t_.promotionList=res.data.promotionList
          t_.total=res.data.total

          if(t_.promotionList.day>1){
            t_.timeArr=formatDuring(t_.promotionList.l).split(':')
          }else{
            t_.timeArr=getTimeLeft(t_.promotionList.l).split(':')
          }
          t_.timer = setInterval(() => {
            if (t_.promotionList.day > 1) {
              t_.promotionList.endTime = formatDuring(t_.promotionList.l)
            } else {
              t_.promotionList.endTime = getTimeLeft(t_.promotionList.l)
            }
            t_.promotionList.l = t_.promotionList.l - 1000
            t_.timeArr=t_.promotionList.endTime.split(':')
            t_.timeArr.forEach(function(item,index){
              t_.timeArr[index]=t_.prefixZero(item,2)
            },t_)
            t_.timeArr=t_.timeArr
            if (t_.promotionList.l == "0:0:0") {
              clearInterval(t_.timer);
            }
          }, 1000);
        }
      })
    },
    prefixZero :function (num, n) {
      return(Array(n).join(0) + num).slice(-n);
    },
    priceSort:function(){
      var t_=this
      t_.goodsList=[]
      t_.page=1
      t_.salesSortNum=0
      t_.priceSortType=1
      t_.salesSortType=0
      t_.comprehensiveSortType=0
      if(t_.priceSortNum==0){
        t_.priceSortNum=1
      }else if(t_.priceSortNum==1){
        t_.priceSortNum=2
      }else if(t_.priceSortNum==2){
        t_.priceSortNum=1
      }
      t_.getPromotionDetails(t_.page)
    },
    salesSort:function(){
      var t_=this
      t_.goodsList=[]
      t_.page=1
      t_.priceSortNum=0
      t_.priceSortType=0
      t_.salesSortType=1
      t_.comprehensiveSortType=0
      t_.showImg=0
      if(t_.salesSortNum==0){
        t_.salesSortNum=1
      }else if(t_.salesSortNum==1){
        t_.salesSortNum=2
      }else if(t_.salesSortNum==2){
        t_.salesSortNum=1
      }
      t_.getPromotionDetails(t_.page)
    },
    comprehensiveSort:function(){
      var t_=this
      t_.goodsList=[]
      t_.page=1
      t_.priceSortNum=0
      t_.salesSortNum=0
      t_.priceSortType=0
      t_.salesSortType=0
      t_.comprehensiveSortType=1
      t_.showImg=0
      t_.getPromotionDetails(t_.page)
    },
    goToGoods:function(goodsId){
      var t_=this
      var href=this.$router.resolve( {name:'goodsdetails',query: {goodsId:goodsId,supplyChainTenantId:goods.supplyChainTenantId,isSupplyChainGoods:2}})
      return window.open(href.href,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.page=val
      this.goodsList=[]
      this.getPromotionDetails(val)
    },
    hover:function(index){
      this.Accord = index
    },
    leave:function(index){
      this.Accord=null
    },
  }
}
</script>
<style>
  .noGoods{
    text-align: center;
    margin-top: 30px;
  }
  .coupon_auto{
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .coupon_detail_title{
    background:#fff;
    margin: 60px 0 20px 50px;
  }
  .coupon_detail_title_txt1{
    font-size: 14px;
    margin-bottom: 20px;
  }
  .coupon_detail_title_txt2{
    line-height: 30px;
  }
  .coupon_detail_title_btn{
    width:70px;
    height: 30px;
    color:#fff;
    background: #f12002;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
  .coupon_detail_title_bg{
    width: 50px;
    height: 50px;
    position: absolute;
    top:-30px;
    left:0;
  }
  .coupon_detail_title_bg img{
    width: 50px;
    height: 50px;
  }
  .coupon_goods_content_title{
    background:#f2f2f2;
    border: 1px solid #e4e4e4;
    padding: 9px 28px;
    margin-bottom: 20px;
  }
  .coupon_goods_content_title li{
    height: 22px;
    width: 54px;
    border:1px solid #e4e4e4;
    background: #fff;
    margin-right: 20px;
    text-align: center;
    line-height: 22px;
    cursor: pointer;
  }
  .coupon_goods_content_title .active{
    color:#ff5f12;
  }
  .coupon_goods_content_title li span{
    margin-left: 10px;
  }
  .coupon_goods_content_title li i{
    width: 7px;
    height: 11px;
    margin-left: 5px;
    margin-top: 6px;
  }
  .coupon_goods_content_title li i img{
    width: 7px;
    height: 11px;
  }
  .GoodsListContentBox ul li{
    width: 224px;
    height: 352px;
    padding: 10px;
    margin-right: 2px;
    float: left;
    margin-bottom: 10px;
    border: 1px solid white;
  }
  .GoodsListContentBox ul .coupon_detail_goods_list_item{
    margin-right: 72px;
    margin-bottom: 20px;
  }
  .GoodsListContentBox ul .coupon_detail_goods_list_item:nth-child(4n){
    margin-right: 0;
  }
  .GoodsListContentBox ul li:nth-child(4n+0){
    margin-right: 0;
  }
  .GoodsListContentBox ul li:hover{
    border: 1px solid #eaeaea;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .GoodsListContentBox ul li a{
    text-decoration: none;
  }
  .goodslistpicbox{
    height: 235px;
    border-bottom: 1px solid #EEEEEE;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #FF6600;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goodslistnamebox p:hover{
    color: #FF6600;
    text-decoration: underline;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 112px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FF6600;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    border-right: 1px solid #eee;
    /*display: none;*/
  }
  .goodslistBtnBox:first-child{
    width: 111px;
  }
  .goodslistBtnBox:last-child{
    border-right: 0;
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#f60;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .coupon_goods_content_list{
    margin-bottom: 50px;
  }
  .activity_time{
    margin-right: 30px;
  }
  .activity_time p:first-child{
    text-align: center;
    margin-bottom: 10px;
  }
  .activity_time i{
    width: 26px;
    height: 26px;
    border-radius: 5px;
    background:#40023c;
    text-align: center;
    line-height: 26px;
    color:#fff;
  }
  .activity_time b{
    line-height: 26px;
  }
  .coupon_detail_goods_page{
    text-align: center;
    padding-bottom: 10px;
  }
  .coupon_detail_goods_page .el-pagination__jump{
    margin-top: -9px;
  }
  .coupon_detail_goods_page .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/activity_detail.vue